import { render, staticRenderFns } from "./ChildPolicy.vue?vue&type=template&id=45dd5f02&"
import script from "./ChildPolicy.vue?vue&type=script&lang=js&"
export * from "./ChildPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ChildPolicy.vue?vue&type=style&index=0&id=45dd5f02&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45dd5f02')) {
      api.createRecord('45dd5f02', component.options)
    } else {
      api.reload('45dd5f02', component.options)
    }
    module.hot.accept("./ChildPolicy.vue?vue&type=template&id=45dd5f02&", function () {
      api.rerender('45dd5f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChildPolicy.vue"
export default component.exports